import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'm-maintanance',
  templateUrl: './maintanance.component.html',
  styleUrls: ['./maintanance.component.scss']
})
export class MaintananceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
